import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { webhookEndpointsMessages } from 'src/features/webhook-endpoints/utils/messages';
import WebhookEndpointFormModal from 'src/features/webhook-endpoints/components/forms/WebhookEndpointFormModal';
import { useCreateWebhookEndpoint } from 'src/features/webhook-endpoints/api/useCreateWebhookEndpoint';
import { LIST_WEBHOOK_ENDPOINTS_RESOURCE } from 'src/features/webhook-endpoints/api/useListWebhookEndpoints';
import { WEBHOOK_ENDPOINT_RESOURCE } from 'src/features/webhook-endpoints/api/useGetWebhookEndpoint';

interface CreateWebhookEndpointFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateWebhookEndpointFormModal<TData>({ className, semantics }: CreateWebhookEndpointFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateWebhookEndpoint({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_WEBHOOK_ENDPOINTS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [WEBHOOK_ENDPOINT_RESOURCE] });
            toast({
                title: formatMessage(webhookEndpointsMessages.createWebhookEndpointSuccess),
                description: formatMessage(webhookEndpointsMessages.createWebhookEndpointSuccessDescription),
            });
        },
    });

    return (
        <WebhookEndpointFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(webhookEndpointsMessages.addWebhookEndpointSubtitle)}
        />
    );
}

export default CreateWebhookEndpointFormModal;
